export interface ProvinciaJSON {
    pro_id: string | null;
    pro_nombre: string;
}

export class Provincia {
    protected constructor(
    private id: string | null,
    private nombre: string) {}

    static createFrom( id: string | null,
    nombre: string) {
        return new this( id,
        nombre)
    }

    isIdentifiedBy(anId: string): boolean {
        return this.id === anId
    }

    isIdentifiedAs(aEntity: Provincia) {
        if(this.id){
            return aEntity.isIdentifiedBy(this.id)
        } else {
            return false
        }

    }

    static fromJSON(entity: ProvinciaJSON) {
        return Provincia.createFrom( entity.pro_id,
        entity.pro_nombre)
    }

    toJSON(): ProvinciaJSON {
        return {
            pro_id: this.getId(),
            pro_nombre: this.getNombre()
        }

    }

    getId(): string | null { return this.id; }

    getNombre(): string { return this.nombre; }

    setId(value: string | null):void { this.id = value; }

    setNombre(value: string):void { this.nombre = value; }

}

